module.exports = __webpack_public_path__ + "static/media/NYULagone.ddca9837.png";